import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BruteForce} from "../BruteForce";
import {BruteForceGameConfig} from "../BruteForceGameConfig";
import {gsap} from "gsap";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {BruteForceGameAssets} from "../BruteForceGameAssets";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {BruteForceSound} from "../sound/BruteForceSound";
import {BruteForceBetlineConfig} from "../BruteForceBetlineConfig";


export class BruteForceBetLineView extends PIXI.Container implements StageLayer {

    private _betLineContainer: TimelineSprite[] = [];
    private _betAmountContainer: PIXI.BitmapText[] = [];
    private _typeOrder: number[] = [];  //stores the betline groups by their order of playing
    private _numOfTypesPresent: number[] = [0, 0, 0, 0, 0]; //stores the number of betlines playing in each group


    constructor() {
        super();
        this.name = `BruteForceBetLineView`;

    }


    public addBetLine(typeNo: number, index: number,): void {
        this.createBetLine(typeNo);   //creates betline animation
        this.createBetLineAmount(typeNo, index);  //creates individual amount at center of each betline
    }

    public showBetLine(isIdleToggle: boolean): gsap.core.Timeline {
        const showAllLinesTl: gsap.core.Timeline = gsap.timeline();
        if (isIdleToggle) {
            this._betLineContainer.forEach((item: TimelineSprite, id: number) => {
                const lineAmount: PIXI.BitmapText = <PIXI.BitmapText>this._betAmountContainer[id];
                const showLineTl: gsap.core.Timeline = this.betlineAnimation(lineAmount, isIdleToggle, id, item);
                showAllLinesTl.add(showLineTl, ">");
            });
        } else {
            for (let group = 1; group <= 5; group++) {

                this._betLineContainer.forEach((item: TimelineSprite, id: number) => {
                    let lineAmount: PIXI.BitmapText;

                    if (item.name.charAt(item.name.length - 1) === group.toString()) {
                        lineAmount = <PIXI.BitmapText>this._betAmountContainer[id];

                        const showLineTl: gsap.core.Timeline = this.betlineAnimation(lineAmount, isIdleToggle, id, item, group);

                        let type: number = +item.name.charAt(item.name.length - 1);
                        showAllLinesTl.add(showLineTl, this.betLineGroupTime(type));

                        showAllLinesTl.add(() => {
                            BruteForceSound.playBetlineHighlights(type - 1);
                        }, "<")

                        if (BruteForce.model.betLineWins[id].symbol.includes("M")) {
                            showAllLinesTl.add(() => {
                                BruteForceSound.playBetlineHighlightsOverlayM(type - 1);
                            }, "<")
                        }
                    }

                })

            }

        }

        showAllLinesTl.add(() => {
            this.betlinePlayingReset();
        })

        return showAllLinesTl;
    }


    public reset(): void {
        this._betLineContainer.forEach((item) => {
            item.destroy();
        });
        this._betAmountContainer.forEach((item) => {
            item.destroy();
        });
        this._betLineContainer = [];
        this._betAmountContainer = [];
        this._typeOrder = [];
        this._numOfTypesPresent = [0, 0, 0, 0, 0];
        this.removeChildren();

    }


    public hideLinesAndAmount(): void {
        this._betLineContainer.forEach((item) => {
            item.visible = false;
        });
        this._betAmountContainer.forEach((item) => {
            item.visible = false;
        });
    }

    public betlineGroupOrdering(): void {
        let noOfTypesPresent: number = 0;
        this._numOfTypesPresent.forEach((typeFreq: number) => {
            if (typeFreq > 0) {
                noOfTypesPresent++;
            }
        })
        while (noOfTypesPresent > 0) {
            let maxFreq: number = 0;
            let maxIndex: number = -1;
            for (let i: number = 0; i < this._numOfTypesPresent.length; i++) {
                this._numOfTypesPresent[i] >= maxFreq ? maxIndex = i : "";
                maxFreq = Math.max(maxFreq, this._numOfTypesPresent[i]);
            }
            this._typeOrder.unshift(maxIndex + 1);
            this._numOfTypesPresent.splice(maxIndex, 1, 0);
            noOfTypesPresent--;
        }
    }

    private betLineGroupTime(type: number): number | undefined {
        let typePosition: number = -1;
        this._typeOrder.forEach((groupType: number, index: number) => {
            if (type === groupType) {
                typePosition = index;
            }
        })
        switch (typePosition) {
            case(0):
                return 0;

            case(1):
                return 1.14;

            case(2):
                return 2.28;

            case(3):
                return 3.42;

            case(4):
                return 4.56;

            default:
                return undefined;
        }
    }

    private createBetLine(index: number): void {
        const incrementFactor: number = 1.2
        let lineType: number = 0;
        if (index <= 4) {
            lineType = 1;
        } else if (index > 4 && index <= 6) {
            lineType = 2;
        } else if (index > 6 && index <= 12) {
            lineType = 3;
        } else if (index > 12 && index <= 20) {
            lineType = 4;
        }
        let currentLine: TimelineSprite = new TimelineSprite(BruteForce.assetLoader.getTextures(`betline_${lineType}`));
        currentLine.anchor.set(0.5, 0.5);
        currentLine.blendMode = PIXI.BLEND_MODES.ADD;
        currentLine.visible = false;
        currentLine.hide();
        switch (index) {
            case 0:
                currentLine.name = `betline_${index}_type_1`;
                currentLine.position.set(360, BruteForceGameConfig.reelSetPositionY + BruteForceGameConfig.symbolHeight * index * incrementFactor);
                this._numOfTypesPresent[0]++;
                break;
            case 1:
                currentLine.name = `betline_${index}_type_2`;
                currentLine.position.set(360, BruteForceGameConfig.reelSetPositionY + BruteForceGameConfig.symbolHeight * index * incrementFactor);
                this._numOfTypesPresent[1]++;
                break;
            case 2:
                currentLine.name = `betline_${index}_type_3`;
                currentLine.position.set(360, BruteForceGameConfig.reelSetPositionY + BruteForceGameConfig.symbolHeight * index * incrementFactor);
                this._numOfTypesPresent[2]++;
                break;
            case 3:
                currentLine.name = `betline_${index}_type_4`;
                currentLine.position.set(360, BruteForceGameConfig.reelSetPositionY + BruteForceGameConfig.symbolHeight * index * incrementFactor);
                this._numOfTypesPresent[3]++;
                break;
            case 4:
                currentLine.name = `betline_${index}_type_5`;
                currentLine.position.set(360, BruteForceGameConfig.reelSetPositionY + BruteForceGameConfig.symbolHeight * index * incrementFactor);
                this._numOfTypesPresent[4]++;
                break;
            case 5:
                currentLine.name = `betline_${index}_type_5`;
                currentLine.position.set(360, 352);
                currentLine.rotation = 3.82;
                currentLine.scale.x = -1;
                this._numOfTypesPresent[4]++;
                break;
            case 6:
                currentLine.name = `betline_${index}_type_1`;
                currentLine.position.set(363, 300 * incrementFactor - 15);
                currentLine.rotation = 2.46;
                currentLine.scale.x = -1;
                this._numOfTypesPresent[0]++;
                break;
            case 7:
                currentLine.name = `betline_${index}_type_1`;
                currentLine.position.set(360, (BruteForceGameConfig.symbolHeight * 5) / 2 - 20);
                this._numOfTypesPresent[0]++;
                break;
            case 8:
                currentLine.name = `betline_${index}_type_2`;
                currentLine.position.set(360, 100 + BruteForceGameConfig.symbolHeight * 2 + 40);
                this._numOfTypesPresent[1]++;
                break;
            case 9:
                currentLine.name = `betline_${index}_type_3`;
                currentLine.position.set(360, 100 + BruteForceGameConfig.symbolHeight * 3 + 60);
                this._numOfTypesPresent[2]++;
                break;
            case 10:
                currentLine.name = `betline_${index}_type_4`;
                currentLine.position.set(360, 360);
                currentLine.rotation = 3.14;
                currentLine.scale.x = -1;
                this._numOfTypesPresent[3]++;
                break;
            case 11:
                currentLine.name = `betline_${index}_type_3`;
                currentLine.position.set(360, 250);
                currentLine.rotation = 3.14;
                currentLine.scale.x = -1;
                this._numOfTypesPresent[2]++;
                break;
            case 12:
                currentLine.name = `betline_${index}_type_5`;
                currentLine.position.set(360, 480);
                currentLine.rotation = 3.14;
                currentLine.scale.x = -1;
                this._numOfTypesPresent[4]++;
                break;
            case 13:
                currentLine.name = `betline_${index}_type_1`;
                currentLine.position.set(360, BruteForceGameConfig.reelSetPositionY + BruteForceGameConfig.symbolHeight / 2);
                this._numOfTypesPresent[0]++;
                break;
            case 14:
                currentLine.name = `betline_${index}_type_2`;
                currentLine.position.set(360, 290);
                this._numOfTypesPresent[1]++;
                break;
            case 15:
                currentLine.name = `betline_${index}_type_3`;
                currentLine.position.set(360, 400);
                this._numOfTypesPresent[2]++;
                break;
            case 16:
                currentLine.name = `betline_${index}_type_4`;
                currentLine.position.set(360, 520);
                this._numOfTypesPresent[3]++;
                break;

            case 17:
                currentLine.name = `betline_${index}_type_5`;
                currentLine.position.set(360, 520);
                currentLine.rotation = 3.15;
                currentLine.scale.x = -1;
                this._numOfTypesPresent[4]++;
                break;

            case 18:
                currentLine.name = `betline_${index}_type_4`;
                currentLine.position.set(360, 400);
                currentLine.rotation = 3.15;
                currentLine.scale.x = -1;
                this._numOfTypesPresent[3]++;
                break;

            case 19:
                currentLine.name = `betline_${index}_type_3`;
                currentLine.position.set(360, 290);
                currentLine.rotation = 3.15;
                currentLine.scale.x = -1;
                this._numOfTypesPresent[2]++;
                break;

            case 20:
                currentLine.name = `betline_${index}_type_2`;
                currentLine.position.set(360, BruteForceGameConfig.reelSetPositionY + BruteForceGameConfig.symbolHeight / 2);
                currentLine.rotation = 3.15;
                currentLine.scale.x = -1;
                this._numOfTypesPresent[1]++;
                break;

            default:
                break;
        }
        this.addChild(currentLine);
        this._betLineContainer.push(currentLine);
    }

    private createBetLineAmount(betlineType: number, index: number): void {
        const individualWinAmount: PIXI.BitmapText = this.addIndividualWinAmount(BruteForce.model.betLineWins[index].multipliedAmount);
        const firstLinePosY: number = 90;
        const expectedSymHeight: number = 115;

        switch (betlineType) {
            case 0:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_1`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, firstLinePosY);
                break;
            case 1:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_2`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, firstLinePosY + expectedSymHeight);
                break;
            case 2:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_3`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, firstLinePosY + expectedSymHeight * 2);
                break;
            case 3:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_4`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, firstLinePosY + expectedSymHeight * 3);
                break;
            case 4:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_5`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, firstLinePosY + expectedSymHeight * 4);
                break;
            case 5:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_5`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, (firstLinePosY + expectedSymHeight * 2) - 30);
                break;
            case 6:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_1`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, (firstLinePosY + expectedSymHeight * 2) - 30);
                break;
            case 7:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_1`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, (firstLinePosY + expectedSymHeight * 2) + 30);
                break;
            case 8:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_2`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, firstLinePosY + expectedSymHeight * 3);
                break;
            case 9:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_3`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, firstLinePosY + expectedSymHeight * 4);
                break;
            case 10:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_4`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, firstLinePosY + expectedSymHeight);
                break;
            case 11:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_3`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, firstLinePosY);
                break;
            case 12:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_5`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, (firstLinePosY + expectedSymHeight * 2) + 30);
                break;
            case 13:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_1`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, firstLinePosY + expectedSymHeight);
                break;
            case 14:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_2`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, firstLinePosY + expectedSymHeight * 2);
                break;
            case 15:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_3`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, firstLinePosY + expectedSymHeight * 3);
                break;
            case 16:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_4`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, firstLinePosY + expectedSymHeight * 4);
                break;
            case 17:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_5`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, firstLinePosY + expectedSymHeight * 3);
                break;
            case 18:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_4`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, firstLinePosY + expectedSymHeight * 2);
                break;
            case 19:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_3`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, firstLinePosY + expectedSymHeight);
                break;
            case 20:
                individualWinAmount.name = `amountOfBetlineType_${index}_Group_2`;
                individualWinAmount.position.set(360 - individualWinAmount.width / 2, firstLinePosY);
                break;
            default:
                break;

        }
        this.addChild(individualWinAmount);
        this._betAmountContainer.push(individualWinAmount);
    }

    private addIndividualWinAmount(value: number): PIXI.BitmapText {
        let winAmount: PIXI.BitmapText = new PIXI.BitmapText("", {
            fontName: BruteForceGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 10
        });
        winAmount.text = SlotGame.apiPlugin.currency.formatValue(value);
        winAmount.maxWidth = 200;
        winAmount.visible = false;
        return winAmount;
    }

    private betlinePlayingReset() {
        for (let i = 0; i < 5; i++) {
            for (let j = 0; j < 5; j++) {
                BruteForceBetlineConfig.isBetlineGroupPlaying_1[i][j] = false;
                BruteForceBetlineConfig.isBetlineGroupPlaying_2[i][j] = false;
                BruteForceBetlineConfig.isBetlineGroupPlaying_3[i][j] = false;
                BruteForceBetlineConfig.isBetlineGroupPlaying_4[i][j] = false;
                BruteForceBetlineConfig.isBetlineGroupPlaying_5[i][j] = false;
            }
        }
    }

    private betlineAnimation(lineAmount: PIXI.BitmapText, isIdleToggle: boolean, id: number, item: TimelineSprite, group?: number): gsap.core.Timeline {
        const showLineTl: gsap.core.Timeline = gsap.timeline();

        //highlights one betline symbols
        BruteForce.model.currentPaylines[id].forEach((symPos: number, reelNo: number) => {
            if (reelNo < BruteForce.model.betLineWins[id].length) {
                showLineTl.add(BruteForce.reelOverlayView.showSymHighlight(symPos, reelNo, isIdleToggle, group), 0);
            }

            //shows betline amount and betline
            showLineTl.add(() => {
                lineAmount.visible = !BruteForce.model.gameData.brokeTheBank;
                lineAmount.alpha = 0;
                item.visible = true;
            }, 0);

        });

        showLineTl.add(<gsap.core.Timeline><unknown>item.getAnimationAutoShowHide(), 0.1);
        showLineTl.to(lineAmount, {alpha: 1, duration: 0.2}, "<");
        showLineTl.to(lineAmount, {alpha: 0, duration: 0.2}, ">0.2");


        //switches no win state per betline(only current betline syms are in win state)
        //for idlenormal toggle all are in win state

        showLineTl.add(() => {
            lineAmount.visible = false;
        }, ">");
        //console.log("showlineTl", showLineTl.totalDuration());

        return showLineTl;
    }
}
